import { Flex, FlexProps } from "..";

export const PageLayoutContent = (props: FlexProps)=> {
  return <Flex flexDirection={"column"} id="page-layout-container" p={4} {...props} />
}
